import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "feature-icon" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "feature-title" }
const _hoisted_4 = { class: "feature-description" }

import { motion } from "motion-v"

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureCard',
  props: {
    title: {},
    description: {},
    icon: {},
    index: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(motion).div, {
    class: "feature-card",
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    transition: { delay: (_ctx.index || 0) * 0.1, duration: 0.5 },
    inViewOptions: { once: true }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          alt: _ctx.title,
          src: require(`@/assets/icons/${_ctx.icon}`)
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1)
    ]),
    _: 1
  }, 8, ["transition"]))
}
}

})